import { useState } from 'react';
import projectAPI from '../../services/projectAPI';
import { Project } from '../../types/project.type';
import SearchPickProjectView from './SearchPickProjectView/SearchPickProjectView'
import useDynamicSearch from '../../../../hook/useDynamicSearch';
import { Pagination as pagniationType } from "../../../../types/responsesAPI.types";
import useErrorHandler from '../../../../hook/useErrorHandler';

interface SearchPickProjectPresenterProps {
  setProject : (project : Project) => void;
  project?: Project  | null;
  onClickCallback? : () => void;
  scrollable?: boolean;
  heightListResult?: string;
  isUserMember?: boolean;

}
export default function SearchPickProjectPresenter({setProject, onClickCallback, scrollable, heightListResult, isUserMember}: SearchPickProjectPresenterProps) {
  const [result, setResult] = useState<Project[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationInfo, setPaginationInfo] = useState<pagniationType | null>(null);
  const {handleNetworkError} = useErrorHandler()

  const apiRequest = async (query: string, currentPage: number, pageSize: number) => {

    if (isUserMember) {
      return projectAPI.searchProjectUserMemberProtectedAPI(query, currentPage, pageSize)
    } else {
      return projectAPI.searchProjectProtectedAPI(query, currentPage, pageSize)
    }

  }
  
  const getSearch = (query: string, callback: () => void) => {
    apiRequest(query, currentPage, 5)
      .then((response) => {
        setResult(response.data || []);
        setPaginationInfo(response.pagination);
        callback();
      })
      .catch((error) => {
        handleNetworkError(error, "employeeSearch")
        callback();
      });
  };
  const [query, setQuery, isLoadingResult,refrechSearch] = useDynamicSearch(getSearch, 0);

  const onSetPagination = (page: number) => {
    setCurrentPage(page);
    refrechSearch();
  }

  const onSetQuery = (query: string) => {
    setCurrentPage(1);
    setPaginationInfo(null);
    setQuery(query);
  }  
  
  return (
  

      <SearchPickProjectView setSearchValue={onSetQuery} searchValue={query} isLoading={isLoadingResult} results={result.map(item =>{return{ title : item.project_name,
        description : item.project_desc,
        project_status: item.project_status,
        onClick : () => {
          setProject(item);
          if (onClickCallback) {
            onClickCallback();
          }

        }
        
      }})}
      heightListResult={heightListResult}
      
      currentPage={currentPage} setCurrentPage={onSetPagination} lastPage={paginationInfo?.total_pages }
      nbFound={paginationInfo?.total_count}
      scrollable={scrollable}
      />
      

    
  )
}
